"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddArticle = AddArticle;
exports.DelArticle = DelArticle;
exports.ListArticle = ListArticle;
exports.UpdateArticle = UpdateArticle;
exports.changeShopSort = changeShopSort;
exports.changeShopState = changeShopState;
exports.getMealBrand = getMealBrand;
exports.getMealCity = getMealCity;
exports.mealOrderDetial = mealOrderDetial;
exports.mealOrderLists = mealOrderLists;
exports.mealRestauratList = mealRestauratList;
exports.mealShopList = mealShopList;
exports.updateMealShop = updateMealShop;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/**
 * 品牌-列表
 */
function mealShopList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/meal/brand/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 品牌-状态
 */
function changeShopState() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/mealBrand/updateStatus',
    method: 'GET',
    params: pram
  });
}

/**
 * 品牌-状态
 */
function changeShopSort() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/meal/brand/update/sort',
    method: 'post',
    data: params
  });
}

/**
 * 品牌-更新
 */
function updateMealShop() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _request.default)({
    url: '/admin/mealBrand/update',
    method: 'post',
    data: data
  });
}

/**
 * 列表
 * @param pram
 * @constructor
 */
function ListArticle() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = pram || {},
    name = _ref.name,
    status = _ref.status,
    page = _ref.page,
    limit = _ref.limit;
  var data = {
    name: name,
    status: status,
    page: page,
    limit: limit
  };
  return (0, _request.default)({
    url: '/admin/store/activity/list',
    method: 'GET',
    params: data
  });
}
var handSubmit = function handSubmit() {
  var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var image = datas.image,
    name = datas.name,
    skuIds = datas.skuIds,
    status = datas.status;
  return {
    image: image,
    name: name,
    skuIds: skuIds,
    status: status
  };
};

/**
 * 新增
 * @param pram
 * @constructor
 */
function AddArticle(pram) {
  return (0, _request.default)({
    url: '/admin/store/activity/save',
    method: 'post',
    data: handSubmit(pram)
  });
}

/**
 * 更新
 * @param pram
 * @constructor
 */
function UpdateArticle(pram) {
  return (0, _request.default)({
    url: '/admin/store/activity/update',
    method: 'post',
    data: _objectSpread(_objectSpread({}, handSubmit(pram)), {}, {
      id: pram.id
    })
  });
}

/**
 * 删除
 * @param id
 * @constructor
 */
function DelArticle(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/store/activity/delete',
    method: 'GET',
    params: data
  });
}

/**
 * 点餐门店-列表
 */
function mealRestauratList() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/meal/restaurant/list',
    method: 'GET',
    params: pram
  });
}

/**
 * 点餐-城市自动补全
 */
function getMealCity() {
  var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // return request({
  //     url: '/admin/mealCity/autoList',
  //     method: 'GET',
  //     params: { keyword },
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/thirdparty/meal/city/autoList',
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 点餐-品牌自动补全
 */
function getMealBrand() {
  var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // return request({
  //     url: '/admin/mealBrand/autoList',
  //     method: 'GET',
  //     params: { keyword },
  // });
  return (0, _requestMapi.default)({
    url: '/mapi/system/admin/meal/autoList',
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}

/**
 * 点餐订单-列表
 */
function mealOrderLists() {
  var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var datas = _objectSpread({}, pram);
  var _ref2 = datas && datas.dataRenage || [],
    _ref3 = _slicedToArray(_ref2, 2),
    startTime = _ref3[0],
    endTime = _ref3[1];
  datas = _objectSpread(_objectSpread({}, datas), {}, {
    startTime: startTime,
    endTime: endTime
  });
  delete datas.dataRenage;
  return (0, _request.default)({
    url: '/admin/order/meal/list',
    method: 'GET',
    params: datas
  });
}

/**
 * 点餐订单-列表
 */
function mealOrderDetial(orderNo) {
  return (0, _request.default)({
    url: "/admin/order/meal/detail/".concat(orderNo),
    method: 'GET',
    params: {
      orderNo: orderNo
    }
  });
}